import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  color?: string;
  size?: number;
};

const Swap: React.FC<Props> = ({ color = "#000", size = 24 }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M7 16L3 12L7 8M17 8L21 12L17 16"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M3 12H21"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Swap;
